// extracted by mini-css-extract-plugin
export default {"roundIcon":"EditVehicleData_roundIcon__UFJQk"};